// Module
var code = `<div class="candidate-profile-status-label candidate-profile-label" ng-if="candidateProfileStatusLabelCtrl.workflowStatus"> <div class="candidate-profile-label__title">{{ 'PROFILE_CURRENT_STATUS' | translate }}</div> <div class="candidate-profile-label__value">{{ candidateProfileStatusLabelCtrl.workflowStatus }}</div> </div>`;
// Exports
export default code;